import React, { useEffect, useRef } from "react"
import { gql, useQuery } from "@apollo/client"
import { useIntercom } from "react-use-intercom"
import { isImpersonating, withAuthProvider } from "../lib/auth"
import { COACH_TOOLS_API } from "../apolloClient"

export const INTERCOM_USER_JWT_QUERY = gql`
  query IntercomUserJwt {
    currentMember {
      intercomUserJwt(platform: WEB)
    }
  }
`

const resolveSession = ({ impersonating, isLoggedIn, intercomUserJwt }) => {
  if (impersonating) return { kind: "off" }
  if (isLoggedIn && intercomUserJwt) {
    return { kind: "verified", jwt: intercomUserJwt }
  }
  return { kind: "anonymous" }
}

const IntercomIdentity = ({ isLoggedIn }) => {
  const { boot, shutdown, hardShutdown } = useIntercom()
  const impersonating = isImpersonating()
  const { data } = useQuery(INTERCOM_USER_JWT_QUERY, {
    context: { api: COACH_TOOLS_API },
    skip: !isLoggedIn || impersonating,
  })
  const intercomUserJwt = data?.currentMember?.intercomUserJwt
  const { kind, jwt } = resolveSession({
    impersonating,
    isLoggedIn,
    intercomUserJwt,
  })
  const appliedSessionRef = useRef(null)

  useEffect(() => {
    const previous = appliedSessionRef.current
    if (
      previous &&
      previous.kind === kind &&
      (kind !== "verified" || previous.jwt === jwt)
    ) {
      return
    }

    if (kind === "off") {
      hardShutdown()
    } else {
      if (previous && previous.kind !== "off") {
        shutdown()
      }
      if (kind === "verified") {
        boot({ intercomUserJwt: jwt })
      } else {
        boot()
      }
    }

    appliedSessionRef.current = { kind, jwt }
  }, [kind, jwt, boot, shutdown, hardShutdown])

  return null
}

const IntercomWithAuth = withAuthProvider(IntercomIdentity)

IntercomWithAuth.displayName = "withAuthProvider(IntercomIdentity)"
export default IntercomWithAuth
